import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Minus } from 'phosphor-react';
import defaultSnacksImage from '../../../../assets/snacks.png';
import './SProductCard.css';

export interface SProductCardProps {
  id: string;
  name: string;
  quantity: string;
  price: number;
  image?: string;
  cartQuantity?: number;
  locationId?: string;
  onAdd?: (productId: string) => void;
  onRemove?: (productId: string) => void;
  onQuantityChange?: (productId: string, quantity: number) => void;
}

const SProductCard: React.FC<SProductCardProps> = ({
  id,
  name,
  price,
  image,
  cartQuantity = 0,
  locationId,
  onAdd,
  onRemove,
  onQuantityChange,
}) => {
  const navigate = useNavigate();
  const [imgSrc, setImgSrc] = useState(image || defaultSnacksImage);
  const [isDefault, setIsDefault] = useState(!image);

  const handleImageError = () => {
    setImgSrc(defaultSnacksImage);
    setIsDefault(true);
  };

  const handleCardClick = () => {
    navigate(`/shop-product/${id}`, { state: { locationId } });
  };

  const handleAdd = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAdd?.(id);
  };

  const handleIncrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    onQuantityChange?.(id, cartQuantity + 1);
  };

  const handleDecrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (cartQuantity <= 0) return;
    if (cartQuantity === 1) onRemove?.(id);
    else onQuantityChange?.(id, cartQuantity - 1);
  };

  return (
    <div className="spc" onClick={handleCardClick}>
      <div className="spc__img">
        <img
          src={imgSrc}
          alt={name}
          onError={handleImageError}
          className={isDefault ? 'spc__img--default' : ''}
        />

        {/* Controls */}
        {cartQuantity > 0 ? (
          <div className="spc__qty" onClick={e => e.stopPropagation()}>
            <button className="spc__qty-btn" onClick={handleDecrement}>
              <Minus size={12} weight="bold" color="#0b0b0a" />
            </button>
            <span className="spc__qty-num">{cartQuantity}</span>
            <button className="spc__qty-btn" onClick={handleIncrement}>
              <Plus size={12} weight="bold" color="#0b0b0a" />
            </button>
          </div>
        ) : (
          <button className="spc__add" onClick={handleAdd}>
            <Plus size={14} weight="bold" color="#0b0b0a" />
          </button>
        )}

        {/* Info overlay */}
        <div className="spc__info">
          <p className="spc__name">{name}</p>
          <span className="spc__price">${price.toFixed(2)}</span>
        </div>

        {/* In-cart indicator */}
        {cartQuantity > 0 && <div className="spc__in-cart" />}
      </div>
    </div>
  );
};

export default SProductCard;
